import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataGrid, { Column, Editing, Lookup, Selection, DataGridTypes } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { FormRef, GroupItem, Label, SimpleItem, ButtonItem } from "devextreme-react/form";
import IPlanEntete from "../../models/IPlanEntete";
import IPlanDetail from '../../models/IPlanDetail';
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import { NumberBox, SelectBox, CheckBox } from 'devextreme-react';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import Guid from '../../models/Guid';
import GestionFolios from '../gestion-folios/gestion-folios';
import CalendarCustom from './calendrier/calendrier';
import useEnum from '../../hooks/useEnum';
import { format, setMonth } from 'date-fns';
import { frCA } from 'date-fns/locale';
import useLoadDataPlans from '../../hooks/gestion-plans/useLoadDataPlans';
import GestionPlansSimple from './gestion-plans-simple';
import GestionActivites from '../gestion-activites/gestion-activites';
import IGestionPlan from '../../models/IGestionPlan';
import useApi from '../../hooks/useApi';
import IPlanDetailTarif from '../../models/IPlanDetailTarif';
import PopupSelectionColonnes from './popup-selection-colonnes';
import { PlanEnteteParametre } from '../../models/IPlanEnteteParametreRequis';
import JoursDisponibilite from '../gestion-points-eau/gestion-point-eau-jours-disponibilites';
import GestionPlanDetailType from '../gestion-plan-detail-types/gestion-plan-detail-types';
import GestionCategoriesClients from '../gestion-categories-clients/gestion-categories-clients';
import GestionTypesEquipements from '../gestion-types-equipements/gestion-types-equipements';
import './gestion-plans.css';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionPlansProps {
  isModeSelection?: boolean,
}

export default function GestionPlans({ isModeSelection }: IGestionPlansProps) {
  const planDataSourceOption: IFormBaseDataSourceOptions<IGestionPlan> = useMemo(() => ({
    path: "planEntete",
    customReadByIdPath: "planEntete/{key}/gestion",
    customSauvegarderPath: "planEntete/save",
    primaryKey: "idPlanEntete",
  }), []);
  const planFormDataSource = useCustomDataSource<IPlanEntete, IGestionPlan>(planDataSourceOption);
  // const planFormDataSource = useCustomDataSource<IPlanEntete, IPlanEntete>({ path: "planEntete", primaryKey: "idPlanEntete" });
  //const planVentilationDataSource = useCustomDataSource<IPlanVentilation>({path: "planVentilation", primaryKey: "idPlanVentilation"});
  const { setMainForm, selectedDataRow: selectedPlan, mode, setSelectedDataRow, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = planFormDataSource;
  const dataGridFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);
  const formRef = useRef<FormRef>(null);
  const { getData } = useApi();
  const [editingPlanDetailRow, setEditingPlanDetailRow] = useState<IPlanDetail | null>(null);
  const { setSelectedValue } = useContextPopupPage();

  const { editorOptions: persAddEditorOption, PopupGestion: PopupGestionPersAdd } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planentete", showClear: mode !== Mode.Lecture, titre: "Gestionnaire des plans", width: "40%",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEntetePersAdd", Guid.empty.toString());
    },
  });
  const { editorOptions: folioEditorOption, PopupGestion: PopupGestionFolios } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "folio", showClear: mode !== Mode.Lecture, titre: "Gestionnaire des folios", width: '75%',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idFolio", Guid.empty.toString());
    },
  });
  const { editorOptions: planEnfantsEditorOption, PopupGestion: PopupGestionPlansEnfants } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planEntete", showClear: mode !== Mode.Lecture, titre: "Gestionnaire des plans", width: '75%',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEnteteEnfant", Guid.empty.toString());
    },
  });
  const { editorOptions: activitesEditorOption, PopupGestion: PopupGestionActivites } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "activite", showClear: mode !== Mode.Lecture, titre: "Gestionnaire des activités", width: '30%',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idActivite", Guid.empty.toString());
    },
  })
  const { editorOptions: trancheAgeEditorOption } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "trancheAge", showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idTrancheAge", Guid.empty.toString());
    },
  });
  const { editorOptions: planDetailTypeEditorOption, PopupGestion: PopupGestionPlanDetailType } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planDetailType", titre: "Gestionnaire des types de détails de plan",
    showClear: false,
    // onClearRow: () => {
    //   setIsFieldModifier(true);

    //   if (editingPlanDetailRow) {
    //     const updatedPlanDetails = selectedPlan.planDetails.map((detail: IPlanDetail) => {
    //       if (detail === editingPlanDetailRow ||
    //         (detail.idPlanDetail && editingPlanDetailRow.idPlanDetail &&
    //           detail.idPlanDetail.equals(editingPlanDetailRow.idPlanDetail))) {
    //         return {
    //           ...detail,
    //           idPlanDetailType: Guid.empty
    //         };
    //       }
    //       return detail;
    //     });
    //     setSelectedDataRow(prev => ({
    //       ...prev,
    //       planDetails: updatedPlanDetails
    //     }));
    //   } else {
    //     // Fallback to form update if no row is being edited
    //     formRef.current?.instance().updateData("idPlanDetailType", Guid.empty.toString());
    //   }
    // },
  });
  const { editorOptions: statutResidentEditorOption } = useEnum(undefined, 'gestionStatutResident');
  const { editorOptions: statutMembreEditorOption } = useEnum(undefined, 'gestionStatutMembre');
  const { editorOptions: modeCalculEditorOption } = useEnum('ventilation');
  const { editorOptions: modeCalculDetailsPrixTarificationEditorOption } = useEnum('tarifiaction');
  const { editorOptions: modeCalculPlanDetailEditorOption } = useEnum('tarifiaction');
  const { editorOptions: modeDeCalculEditorOption } = useEnum(undefined, 'gestionPlansModeCalcul');
  const { editorOptions: uniteEditorOption } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "unite", showClear: mode !== Mode.Lecture,
  });
  const { editorOptions: categorieClientEditorOption, PopupGestion: PopupGestionCategorieClient } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "categorieclient", showClear: mode !== Mode.Lecture, titre: "Gestion des catégories de clients"
  });
  const { editorOptions: typeEquipementEditorOption, PopupGestion: PopupGestionTypeEquipement } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "uniteEquipmentType", showClear: mode !== Mode.Lecture, titre: "Gestionnaire des types d'équipements"
  });

  const {
    // dataHorsService,
    dataTarification,
    // dataVentilation,
    _loadData
  } = useLoadDataPlans(selectedPlan?.idPlanEntete || Guid.empty)

  const currentLocale = frCA
  const mois = Array.from({ length: 12 }, (_, index) =>
    format(setMonth(new Date(), index), "MMMM", { locale: currentLocale })
  );
  const [moisSelectionne, setMoisSelectionne] = useState<string>(format(new Date(), "MMMM", { locale: currentLocale }));
  const [anneSelectionnee, setAnneSelectionnee] = useState<number>(new Date().getFullYear())
  const [isPopupSelectionColonnesVisible, setIsPopupSelectionColonnesVisible] = useState(false);

  useEffect(() => {
    if (selectedPlan) {
      _loadData()
    }
  }, [selectedPlan, moisSelectionne, anneSelectionnee])

  const planDetailDataSourceOptions = useMemo<IFormBaseDataSourceOptions>(() => {
    return { path: "planDetail", primaryKey: "idPlanDetail" }
  }, [selectedPlan?.idPlanEntete]);
  const planDetailDataSource = useCustomDataSource<IPlanDetail, IPlanDetail>(planDetailDataSourceOptions);

  const forfaits = [
    { id: -1, text: "Forfait durée de l'unité/personnes" },// quantité = personnes * jours
    { id: 0, text: "Forfait global" }, // quantité = 1
    { id: 1, text: "Forfait journalier" },// quantité = jours
    { id: 2, text: "Forfait individuel" },
  ];

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })
  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("descriptionFrancaise")?.focus();
  }, [mode])

  const onTarificationSelectionChanged = useCallback(async ({ selectedRowsData }: DataGridTypes.SelectionChangedEvent) => {
    if (selectedRowsData.length > 0) {
      const selectedTarification = selectedRowsData[0] as IPlanDetailTarif;
      if (selectedTarification?.idPlanDetailTarif) {
        try {
          const result = await getData<any>({
            customPath: `planEntete/getConditions/${selectedTarification.idPlanDetailTarif.toString()}`,
            returnOnly: true
          });

          setSelectedDataRow(prev => ({
            ...prev,
            conditions: result?.length > 0 ? result : []
          }));
          // console.log('Server response:', result);
        } catch (error) {
          console.error('Error calling server function:', error);
        }
      }
    }
  }, [getData]);

  const btnSelectionnerOptions = useMemo(() => ({
    text: "Sélectionner les colonnes de détails à utiliser",
    disabled: mode === Mode.Lecture,
    onClick: () => setIsPopupSelectionColonnesVisible(true)
  }), [mode]);

  const { inclureEnfantsOptions, taxableTpsOptions, taxesInclusesOptions, tpsRemboursableOptions, taxableTvqOptions, taxeHebergementIncluseOptions, dejeunerInclusOptions, dinerInclusOptions, souperInclusOptions, actifOptions, repartirSejourOptions, forfaitsOptions, nombrePersonnesOptions, descriptionWebOptions } = useMemo(() => {
    return {
      inclureEnfantsOptions: { text: "Inclure les enfants dans le nombre de personnes (et ignorer le plan enfant)" },
      taxableTpsOptions: { text: "Taxable TPS" },
      taxesInclusesOptions: { text: "Taxes incluses" },
      tpsRemboursableOptions: { text: "TPS remboursable non-résidents" },
      taxableTvqOptions: { text: "Taxable TVQ" },
      taxeHebergementIncluseOptions: { text: "Taxe d'hébergement incluse" },
      dejeunerInclusOptions: { text: "Déjeuner inclus" },
      dinerInclusOptions: { text: "Diner inclus" },
      souperInclusOptions: { text: "Souper inclus" },
      actifOptions: { text: "Actif" },
      repartirSejourOptions: { text: "Répartir le séjour complet selon les détails de plan lors du décorticage" },
      forfaitsOptions: {
        items: forfaits,
        valueExpr: "id",
        displayExpr: "text",
        onValueChanged: (e: any) => {
          const formInstance = formRef.current?.instance();
          const value = e.value;

          if (value === 0) {
            // Forfait global
            formInstance?.updateData("forfaitGlobal", true);
            formInstance?.updateData("forfaitJournalier", false);
            formInstance?.updateData("forfaitIndividuel", false);
          } else if (value === 1) {
            // Forfait journalier
            formInstance?.updateData("forfaitGlobal", false);
            formInstance?.updateData("forfaitJournalier", true);
            formInstance?.updateData("forfaitIndividuel", false);
          } else if (value === 2) {
            // Forfait individuel
            formInstance?.updateData("forfaitGlobal", false);
            formInstance?.updateData("forfaitJournalier", false);
            formInstance?.updateData("forfaitIndividuel", true);
          } else if (value === -1) {
            // Forfait durée de l'unité/personnes - all false
            formInstance?.updateData("forfaitGlobal", false);
            formInstance?.updateData("forfaitJournalier", false);
            formInstance?.updateData("forfaitIndividuel", false);
          }

          setIsFieldModifier(true);
        }
      },
      nombrePersonnesOptions: { min: 0, max: 999, showSpinButtons: true, width: "60px" },
      descriptionWebOptions: { height: 175 }
    };
  }, []);


  const facturerEnfantOptions = useMemo(() => {
    return {
      text: selectedPlan?.prixEnfantUtiliserPourcentageAdulte
        ? "Pour les détails, facturer pour les enfants un pourcentage du prix a"
        : "Pour les détails, facturer pour les enfants un pourcentage du prix des adultes de"
    };
  }, [selectedPlan?.prixEnfantUtiliserPourcentageAdulte]);

  const pourcentageAFacturerOptions = useMemo(() => {
    return {
      format: "#,##0.00",
      step: 0.01,
      min: 0,
      max: 100,
      showSpinButtons: true,
      width: 100
    };
  }, []);

  const isTypeRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.Type && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isDescriptionFrRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.DescriptionFr && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isDescriptionEnRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.DescriptionEn && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const showDescriptionColumns = useMemo(() => {
    return isDescriptionFrRequis || isDescriptionEnRequis;
  }, [isDescriptionFrRequis, isDescriptionEnRequis]);

  const showDescriptionColumn = useMemo(() => {
    return isTypeRequis || showDescriptionColumns;
  }, [isTypeRequis, showDescriptionColumns]);

  const isUniteRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.Unite && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isTypeEquipementRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.TypeEquipement && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isCategorieClientRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.CategorieClient && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isStatutResidentRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.StatutResident && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isStatutMembreRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.StatutMembre && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const showCritereColumn = useMemo(() => {
    return isUniteRequis || isTypeEquipementRequis || isCategorieClientRequis || isStatutResidentRequis || isStatutMembreRequis;
  }, [isUniteRequis, isTypeEquipementRequis, isCategorieClientRequis, isStatutResidentRequis, isStatutMembreRequis]);

  const isDatesDebutFinRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.DatesDebutFin && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const showDatesColumn = useMemo(() => {
    return isDatesDebutFinRequis;
  }, [isDatesDebutFinRequis]);

  const isDureeRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.Duree && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isNbAdultesRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.NbAdultes && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isNbEnfantsRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.NbEnfants && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const isAutantEnfantsQueAdultesRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.AutantEnfantsQueAdultes && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const showConditionsColumn = useMemo(() => {
    return isDureeRequis || isNbAdultesRequis || isNbEnfantsRequis || isAutantEnfantsQueAdultesRequis;
  }, [isDureeRequis, isNbAdultesRequis, isNbEnfantsRequis, isAutantEnfantsQueAdultesRequis]);

  const isJoursSemaineRequis = useMemo(() => {
    return selectedPlan?.parametres?.some(p => p.parametre === PlanEnteteParametre.JoursSemaine && p.requis) ?? false;
  }, [selectedPlan?.parametres]);

  const showJoursSemaineColumn = useMemo(() => {
    return isJoursSemaineRequis;
  }, [isJoursSemaineRequis]);

  const onChexBoxChange = useCallback((value: number, rowIndex: number) => {

    // TODO bug on ajout new element
    if (mode !== Mode.Lecture && selectedPlan?.planDetails && typeof rowIndex === "number" && rowIndex >= 0 && rowIndex < selectedPlan.planDetails.length) {
      setIsFieldModifier(true)
      const newData = [...selectedPlan.planDetails];
      newData[rowIndex].joursChoisis = value;
      setSelectedDataRow((prevState) => {
        return {
          ...prevState,
          planDetails: newData
        }
      })
    }
  }, [mode])

  const renderJoursSemaine = useCallback((cellData: any) => {
    return (
      <JoursDisponibilite
        pointEauSelected={cellData.data.joursChoisis}
        isModeModifier={mode === Mode.Lecture}
        onChexBoxChange={(value: number) => onChexBoxChange(value, cellData.rowIndex)}
        isHorizontal={true}
      />
    );
  }, [mode]);

  const renderModeCalcul = useCallback((cellData: any) => {
    const text = cellData?.data?.forfaitIndividuel
      ? 'Forfait individuel' : cellData?.data?.forfaitJournalier
        ? 'Forfait journalier' : cellData?.data?.forfaitGlobal
          ? 'Forfait global' : "Forfait durée de l'unité/personnes";
    return <div>{text}</div>;
  }, []);

  const onColorValueChanged = useCallback((fieldName: 'couleurPlanBackground' | 'couleurPlanTexte', value: any) => {
    let intValue: number = 0;
    if (value) {
      if (typeof value === 'string') {
        intValue = parseInt(value.replace('#', ''), 16);
      } else if (typeof value === 'number') {
        intValue = value;
      }
    }

    setSelectedDataRow(prev => {
      if (!prev) {
        return { [fieldName]: intValue } as any;
      }
      if (prev[fieldName] === intValue) {
        return prev;
      }
      return {
        ...prev,
        [fieldName]: intValue
      };
    });
    setIsFieldModifier(true);
  }, []);

  const couleurPlanBackgroundEditorOptions = useMemo(() => ({
    onValueChanged: (e: any) => {
      onColorValueChanged('couleurPlanBackground', e.value);
    },
    elementAttr: {
      class: 'colorbox-icon-right'
    }
  }), [onColorValueChanged]);

  const couleurPlanTexteEditorOptions = useMemo(() => ({
    onValueChanged: (e: any) => {
      onColorValueChanged('couleurPlanTexte', e.value);
    },
    elementAttr: {
      class: 'colorbox-icon-right'
    }
  }), [onColorValueChanged]);

  // Convert form data to display format (integers to hex strings for colors)
  const formDataForDisplay = useMemo(() => {
    if (!selectedPlan) {
      return {} as IPlanEntete;
    }
    return {
      ...selectedPlan,
      couleurPlanBackground: selectedPlan.couleurPlanBackground
        ? `#${selectedPlan.couleurPlanBackground.toString(16).padStart(6, '0').toUpperCase()}`
        : undefined,
      couleurPlanTexte: selectedPlan.couleurPlanTexte
        ? `#${selectedPlan.couleurPlanTexte.toString(16).padStart(6, '0').toUpperCase()}`
        : undefined
    } as any;
  }, [selectedPlan]);

  return (
    <FormListBase data={planFormDataSource}>
      <FormListBaseGrid dataSource={planFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
          if (setSelectedValue && e.row?.data)
            setSelectedValue(e.row.data);
        }}
      >
        <Column key={"grid-col-description"} dataField={"descriptionFrancaise"} caption="Description" allowHiding={false} />
        <Column key={"grid-col-folio"} dataField={"idFolio"} caption="Folio" allowHiding={false}>
          <Lookup {...folioEditorOption} />
        </Column>
        <Column key={"grid-col-prix-adultes"} dataField={"prixAdulte"} caption="Prix adultes" allowHiding={false} />
        <Column key={"grid-col-prix-enfant"} dataField={"prixEnfant"} caption="Prix enfant" allowHiding={false} />
        <Column key={"grid-col-mode-calcul"} dataType="object" dataField={"modeCalcul"} caption="Mode de calcul" allowHiding={false}
          cellRender={renderModeCalcul}
        />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedPlan?.descriptionFrancaise || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <PopupGestionFolios
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idFolio", data.idFolio);
            }}
          >
            <GestionFolios isModeSelection={true} />
          </PopupGestionFolios>
          <PopupGestionPersAdd
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPlanEntetePersAdd", data.idPlanEntete);
            }}
          >
            <GestionPlansSimple isModeSelection={true} />
          </PopupGestionPersAdd>
          <PopupGestionPlansEnfants
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPlanEnteteEnfant", data.idPlanEntete);
            }}
          >
            <GestionPlansSimple isModeSelection={true} />
          </PopupGestionPlansEnfants>
          <PopupGestionActivites
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idActivite", data.idActivite);
            }}
          >
            <GestionActivites isModeSelection={true} />
          </PopupGestionActivites>
          <PopupGestionPlanDetailType
            onSelectionchanged={(data: any) => {

              setIsFieldModifier(true);

              if (editingPlanDetailRow) {
                const updatedPlanDetails = selectedPlan.planDetails.map((detail: IPlanDetail) => {

                  if (detail === editingPlanDetailRow ||
                    (detail.idPlanDetail && editingPlanDetailRow.idPlanDetail &&
                      detail.idPlanDetail.equals(editingPlanDetailRow.idPlanDetail))) {
                    return {
                      ...detail,
                      idPlanDetailType: data.idPlanDetailType
                    };
                  }
                  return detail;
                });
                setSelectedDataRow(prev => ({
                  ...prev,
                  planDetails: updatedPlanDetails
                }));
              } else {
                // Fallback to form update if no row is being edited
                formRef.current?.instance().updateData("idPlanDetailType", data.idPlanDetailType);
              }
            }}
          >
            <GestionPlanDetailType isModeSelection={true} />
          </PopupGestionPlanDetailType>
          <PopupGestionCategorieClient
            onSelectionchanged={(data: any) => {

              setIsFieldModifier(true);

              if (editingPlanDetailRow) {
                const updatedPlanDetails = selectedPlan.planDetails
                  .map((detail: IPlanDetail) => {
                    if (detail === editingPlanDetailRow ||
                      (detail.idPlanDetail && editingPlanDetailRow.idPlanDetail &&
                        detail.idPlanDetail.equals(editingPlanDetailRow.idPlanDetail))) {
                      return {
                        ...detail,
                        idCategorieClient: data.idCategorieClient
                      };
                    }
                    return detail;
                  });
                setSelectedDataRow(prev => ({
                  ...prev,
                  planDetails: updatedPlanDetails
                }));
              } else {
                // Fallback to form update if no row is being edited
                formRef.current?.instance().updateData("idCategorieClient", data.idCategorieClient);
              }
            }}
          >
            <GestionCategoriesClients isModeSelection={true} />
          </PopupGestionCategorieClient>
          <PopupGestionTypeEquipement
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);

              if (editingPlanDetailRow) {
                const updatedPlanDetails = selectedPlan.planDetails
                  .map((detail: IPlanDetail) => {
                    if (detail === editingPlanDetailRow ||
                      (detail.idPlanDetail && editingPlanDetailRow.idPlanDetail &&
                        detail.idPlanDetail.equals(editingPlanDetailRow.idPlanDetail))) {
                      return {
                        ...detail,
                        idUniteEquipementType: data.idUniteEquipmentType
                      };
                    }
                    return detail;
                  });
                setSelectedDataRow(prev => ({
                  ...prev,
                  planDetails: updatedPlanDetails
                }));
              } else {
                // Fallback to form update if no row is being edited
                formRef.current?.instance().updateData("idUniteEquipementType", data.idUniteEquipmentType);
              }
            }}
          >
            <GestionTypesEquipements isModeSelection={true} />
          </PopupGestionTypeEquipement>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={formDataForDisplay} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem>
                <GroupItem colCount={5}>
                  <GroupItem colSpan={2}>
                    <SimpleItem key={"frm-description-fr"} dataField={"descriptionFrancaise"}
                    >
                      <Label text={"Description française"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-description-en"} dataField={"descriptionAnglaise"}
                    >
                      <Label text={"Description anglaise"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-folio"}
                      dataField={"idFolio"}
                      editorType={"dxSelectBox"}
                      editorOptions={folioEditorOption}
                    >
                      <Label text={"Folio"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-plan-enfants"}
                      dataField={"idPlanEnteteEnfant"}
                      editorType={"dxSelectBox"}
                      editorOptions={planEnfantsEditorOption}
                    >
                      <Label text={"Plan pour enfants"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-inclure-enfants"}
                      dataField={"inclureEnfantsDansNombrePersonnes"}
                      editorType={"dxCheckBox"}
                      editorOptions={inclureEnfantsOptions}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <GroupItem colCount={2}>
                      <SimpleItem
                        key={"frm-facturer-enfant"}
                        dataField={"prixEnfantUtiliserPourcentageAdulte"}
                        editorType="dxCheckBox"
                        editorOptions={facturerEnfantOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem
                        key={"frm-poucentage-a-facturer"}
                        dataField={"prixEnfantPourcentageAdulte"}
                        editorType="dxNumberBox"
                        editorOptions={pourcentageAFacturerOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                    </GroupItem>
                  </GroupItem>
                  <GroupItem colSpan={1}>
                    <GroupItem caption={"Restauration"}>
                      <SimpleItem key={"frm-dejeuner-inclus"} dataField={"dejeunerInclus"} editorType={"dxCheckBox"}
                        editorOptions={dejeunerInclusOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem key={"frm-diner-inclus"} dataField={"dinerInclus"} editorType={"dxCheckBox"}
                        editorOptions={dinerInclusOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem key={"frm-souper-inclus"} dataField={"souperInclus"} editorType={"dxCheckBox"}
                        editorOptions={souperInclusOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem caption={"Couleur de calendrier"}>
                      <SimpleItem key={"frm-note"}>
                        <label>Note: La couleur du plan à priorité sur la couleur du statut de la réservation</label>
                      </SimpleItem>
                      <SimpleItem key={"frm-couleur-arriere-plan"} dataField={"couleurPlanBackground"} editorType={"dxColorBox"}
                        editorOptions={couleurPlanBackgroundEditorOptions}
                      >
                        <Label text={"Couleur de l'arrière-plan"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-couleur-texte"} dataField={"couleurPlanTexte"} editorType={"dxColorBox"}
                        editorOptions={couleurPlanTexteEditorOptions}
                      >
                        <Label text={"Couleur du texte"} />
                      </SimpleItem>
                    </GroupItem>
                  </GroupItem>
                  <GroupItem colSpan={2}>
                    <GroupItem caption={"Statut et mode de calcul"}>
                      <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                        editorOptions={actifOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem key={"frm-forfaits"}
                        dataField='modeCalcul' editorType={"dxRadioGroup"}
                        editorOptions={forfaitsOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                      <SimpleItem key={"frm-rapartir-sejour"}
                        dataField={"repartirJourneesSejourDecortiquer"}
                        editorType={"dxCheckBox"}
                        editorOptions={repartirSejourOptions}
                      >
                        <Label visible={false} />
                      </SimpleItem>
                    </GroupItem>
                  </GroupItem>
                </GroupItem>
                <GroupItem colCount={3}>
                  <GroupItem>
                    <SimpleItem
                      key={"frm-prix-adulte"}
                      dataField={"prixAdulte"}
                      editorType="dxNumberBox"
                      editorOptions={{
                        format: "#,##0.00 $",
                        step: 0.01,
                        min: 0,
                        showSpinButtons: true
                      }}
                    >
                      <Label text={"Prix adulte"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-prix-enfant"}
                      dataField={"prixEnfant"}
                      editorType="dxNumberBox"
                      editorOptions={{
                        format: "#,##0.00 $",
                        step: 0.01,
                        min: 0,
                        showSpinButtons: true
                      }}
                    >
                      <Label text={"Prix enfant"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-frais-services"}
                      dataField={"fraisServices"}
                      editorType="dxNumberBox"
                      editorOptions={{
                        format: "#,##0.00",
                        step: 0.01,
                        min: 0,
                        showSpinButtons: true
                      }}
                    >
                      <Label text={"Frais de services (%)"} />
                    </SimpleItem>
                    <ButtonItem key={"frm-btn-selectionner"} buttonOptions={btnSelectionnerOptions} />
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem key={"frm-taxable-tps"} dataField={"taxableTps"} editorType={"dxCheckBox"}
                      editorOptions={taxableTpsOptions}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-taxes-incluses"} dataField={"tpsIncluse"} editorType={"dxCheckBox"}
                      editorOptions={taxesInclusesOptions}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-tps-remboursable"} dataField={"tpsRemboursableNonResident"} editorType={"dxCheckBox"}
                      editorOptions={tpsRemboursableOptions}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <SimpleItem key={"frm-taxable-tvq"} dataField={"taxableTvq"} editorType={"dxCheckBox"}
                      editorOptions={taxableTvqOptions}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-taxe-hebergement-incluse"} dataField={"txHebIncluse"} editorType={"dxCheckBox"}
                      editorOptions={taxeHebergementIncluseOptions}
                    >
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                </GroupItem>
                <GroupItem>
                  <GroupItem caption={"Détails du plan"}>
                    <DataGrid
                      dataSource={selectedPlan.planDetails}
                      allowColumnReordering={false}
                      filterValue={dataGridFilterValue}
                      height={"100%"}
                      onInitNewRow={(e: any) => {
                        e.data.idPlanEntete = selectedPlan.idPlanEntete;
                        e.data.isDeleted = false;
                      }}
                      onEditorPreparing={(e: any) => {
                        // Garde en mémoire la row en cours d'édition
                        if ((e.dataField === "idPlanDetailType" || e.dataField === "idCategorieClient" || e.dataField === "idUniteEquipementType") && e.row?.data) {
                          setEditingPlanDetailRow(e.row.data);
                        }

                        const originalOnValueChanged = e.editorOptions.onValueChanged;
                        e.editorOptions.onValueChanged = (args: any) => {
                          if (originalOnValueChanged) {
                            originalOnValueChanged(args);
                          }

                          const currentData = e.component.option("dataSource");
                          const rowIndex = e.rowIndex;
                          const rowData = currentData[rowIndex];

                          const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                          setSelectedDataRow(prev => ({
                            ...prev,
                            planDetails: updatedData
                          }));
                          setIsFieldModifier(true);
                        };
                      }}
                      onRowRemoving={async (e) => {
                        e.cancel = true;
                        const index = selectedPlan.planDetails.findIndex(item =>
                          item.idPlanDetail?.equals(e.data.idPlanDetail)
                        );
                        if (index !== -1) {
                          const updatedData = [...selectedPlan.planDetails];
                          updatedData[index] = { ...updatedData[index], isDeleted: true };
                          setSelectedDataRow(prev => ({
                            ...prev,
                            planDetails: updatedData
                          }));
                          setIsFieldModifier(true);
                        }
                      }}
                    >
                      <Editing
                        mode="cell"
                        allowUpdating={mode !== Mode.Lecture}
                        allowDeleting={mode !== Mode.Lecture}
                        allowAdding={mode !== Mode.Lecture}
                        newRowPosition={"first"}
                        startEditAction={"click"}
                      />
                      {showDescriptionColumn && (
                        <Column caption={"Description"}>
                          {isTypeRequis && (
                            <Column dataField="idPlanDetailType" dataType="string" caption={"Type"}
                            // BUG le lookup ne fonctionne pas avec le editorOptions
                            // editorOptions={planDetailTypeEditorOption}
                            >
                              <Lookup {...planDetailTypeEditorOption} />
                            </Column>
                          )}
                          {showDescriptionColumns && (
                            <>
                              <Column dataField="description" dataType="string" caption={"Français"} />
                              <Column dataField="descriptionAnglais" dataType="string" caption={"Anglais"} />
                            </>
                          )}
                        </Column>
                      )}
                      {showCritereColumn && (
                        <Column caption={"Critères"}>
                          {isUniteRequis && (
                            <Column dataField="idUnite" dataType="string" caption={"Unité"}>
                              <Lookup {...uniteEditorOption} />
                            </Column>
                          )}
                          {isTypeEquipementRequis && (
                            <Column dataField="idUniteEquipementType" dataType="string" caption={"Type d'équipement"}
                            // BUG le lookup ne fonctionne pas avec le editorOptions
                            // editorOptions={typeEquipementEditorOption}
                            >
                              <Lookup {...typeEquipementEditorOption} />
                            </Column>
                          )}
                          {isCategorieClientRequis && (
                            <Column dataField="idCategorieClient" dataType="string" caption={"Catégorie de client"}
                            // BUG le lookup ne fonctionne pas avec le editorOptions
                            // editorOptions={categorieClientEditorOption}
                            >
                              <Lookup {...categorieClientEditorOption} />
                            </Column>
                          )}
                          {isStatutResidentRequis && (
                            <Column dataField="statutResident" dataType="number" caption={"Statut résident"}>
                              <Lookup {...statutResidentEditorOption} />
                            </Column>
                          )}
                          {isStatutMembreRequis && (
                            <Column dataField="statutMembre" dataType="number" caption={"Statut membre"}>
                              <Lookup {...statutMembreEditorOption} />
                            </Column>
                          )}
                        </Column>
                      )}

                      {showDatesColumn && (
                        <Column caption={"Dates"}>
                          <Column dataField="dateDebut" dataType="datetime" caption={"Début"} format="dd-MM-yyyy HH:mm" />
                          <Column dataField="dateFin" dataType="datetime" caption={"Fin"} format="dd-MM-yyyy HH:mm" />
                        </Column>
                      )}
                      {showConditionsColumn && (
                        <Column caption={"Conditions"}>
                          {isDureeRequis && (
                            <Column dataField="nombreJours" dataType="number" caption={"Durée de l'unité <= à"} />
                          )}
                          {isNbAdultesRequis && (
                            <Column dataField="nombreAdultes" dataType="number" caption={"Nb. adultes <= à"} />
                          )}
                          {isNbEnfantsRequis && (
                            <Column dataField="nombreEnfants" dataType="number" caption={"Nb. enfants <= à"} />
                          )}
                          {isAutantEnfantsQueAdultesRequis && (
                            <Column dataField="autantEnfantsQueAdultes" dataType="boolean" caption={"Permettre autant d'enfants que d'adultes avant de facturer des enfants additionnels"} />
                          )}
                        </Column>
                      )}
                      <Column caption={"Prix"}>
                        <Column dataField="prixAdulte" dataType="number" caption={"Adulte"} />
                        <Column dataField="prixEnfant" dataType="number" caption={"Enfant"} />
                      </Column>
                      {showJoursSemaineColumn && (
                        <Column width={340} caption={"Journées"}
                          cellRender={renderJoursSemaine}>
                          {/* <Column dataType="boolean" caption={"Lun."} />
                          <Column dataType="boolean" caption={"Mar."} />
                          <Column dataType="boolean" caption={"Mer."} />
                          <Column dataType="boolean" caption={"Jeu."} />
                          <Column dataType="boolean" caption={"Ven."} />
                          <Column dataType="boolean" caption={"Sam."} />
                          <Column dataType="boolean" caption={"Dim."} /> */}
                        </Column>
                      )}
                      <Column caption={"Mode de calcul"} dataField="modeCalcul" dataType="number">
                        <Lookup {...modeDeCalculEditorOption} />
                      </Column>
                      <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    </DataGrid>
                  </GroupItem>
                  <SimpleItem

                  >
                    <label><strong>Notes:</strong> La formule pour calculer le montant total du plan sera:</label>
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Hors-service">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPlan || {} as IPlanEntete} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem>
                <DataGrid
                  dataSource={selectedPlan.horsServices}
                  allowColumnReordering={false}
                  filterValue={dataGridFilterValue}
                  height={"100%"}
                  onInitNewRow={(e: any) => {
                    e.data.idPlanEntete = selectedPlan.idPlanEntete;
                    e.data.isDeleted = false;
                  }}
                  onEditorPreparing={(e: any) => {
                    const originalOnValueChanged = e.editorOptions.onValueChanged;
                    e.editorOptions.onValueChanged = (args: any) => {
                      if (originalOnValueChanged) {
                        originalOnValueChanged(args);
                      }

                      const currentData = e.component.option("dataSource");
                      const rowIndex = e.rowIndex;
                      const rowData = currentData[rowIndex];

                      const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                      setSelectedDataRow(prev => ({
                        ...prev,
                        horsServices: updatedData
                      }));
                      setIsFieldModifier(true);
                    };
                  }}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    const index = selectedPlan.horsServices.findIndex(item =>
                      item.idUniteHorsService?.equals(e.data.idUniteHorsService)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedPlan.horsServices];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        horsServices: updatedData
                      }));
                      setIsFieldModifier(true);
                    }
                  }}
                >
                  <Editing
                    mode='cell'
                    allowAdding={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowUpdating={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"}
                  />
                  <Column caption={"Date début"} dataField='dateDebut' dataType="date" format="dd-MM-yyyy" editorOptions={{
                    type: 'date',
                    displayFormat: 'dd-MM-yyyy'
                  }} />
                  <Column caption={"Date fin"} dataField='dateFin' dataType="date" format="dd-MM-yyyy" editorOptions={{
                    type: 'date',
                    displayFormat: 'dd-MM-yyyy'
                  }} />
                  <Column caption={"Description"} dataField='description' />
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                </DataGrid>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Internet">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPlan || {} as IPlanEntete} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem caption={"Personnes additionnelles (Les informations dans unité et type d'unité ont priorité sur celles-ci)"}>
                <GroupItem alignItemLabels={false}>
                  <SimpleItem key={"frm-plan"}
                    dataField={"idPlanEntetePersAdd"}
                    editorType={"dxSelectBox"}
                    editorOptions={persAddEditorOption}
                  >
                    <Label text={"Plan pour personnes additionnelles"} />
                  </SimpleItem>
                </GroupItem>
                <SimpleItem key={"frm-nombre-personnes"}
                  dataField={"nbPersonnesAvantPlanPersAdd"}
                  editorType={"dxNumberBox"}
                  editorOptions={nombrePersonnesOptions}
                >
                  <Label text={"Nombre de personnes avant de facturer des personnes additionnelles"} />
                </SimpleItem>
                <SimpleItem key={"frm-nombre-adultes"}
                  dataField={"nbAdultesAvantPlanAdd"}
                  editorType={"dxNumberBox"}
                  editorOptions={nombrePersonnesOptions}
                >
                  <Label text={"Nombre d'adultes avant de facturer des adultes additionnels"} />
                </SimpleItem>
                <SimpleItem key={"frm-nombre-enfants"}
                  dataField={"nbEnfantsAvantPlanAdd"}
                  editorType={"dxNumberBox"}
                  editorOptions={nombrePersonnesOptions}
                >
                  <Label text={"Nombre d'enfants avant de facturer des enfant additionnels"} />
                </SimpleItem>
              </GroupItem>
              <SimpleItem key={"frm-description-web-fr"} dataField={"descriptionWeb"} editorType={"dxTextArea"} editorOptions={descriptionWebOptions}
              >
                <Label text={"Description web française"} location={"top"} />
              </SimpleItem>
              <SimpleItem key={"frm-description-web-en"} dataField={"descriptionWebAnglais"} editorType={"dxTextArea"} editorOptions={descriptionWebOptions}
              >
                <Label text={"Description web en anglais"} location={"top"} />
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="Ventilation">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPlan || {} as IPlanEntete} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem>
                <DataGrid
                  dataSource={selectedPlan.ventilations}
                  allowColumnReordering={false}
                  filterValue={dataGridFilterValue}
                  height={"100%"}
                  onInitNewRow={(e: any) => {
                    e.data.idPlanEntete = selectedPlan.idPlanEntete;
                    e.data.isDeleted = false;
                  }}
                  onEditorPreparing={(e: any) => {
                    const originalOnValueChanged = e.editorOptions.onValueChanged;
                    e.editorOptions.onValueChanged = (args: any) => {
                      if (originalOnValueChanged) {
                        originalOnValueChanged(args);
                      }

                      const currentData = e.component.option("dataSource");
                      const rowIndex = e.rowIndex;
                      const rowData = currentData[rowIndex];

                      const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                      setSelectedDataRow(prev => ({
                        ...prev,
                        ventilations: updatedData
                      }));
                      setIsFieldModifier(true);
                    };
                  }}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    const index = selectedPlan.ventilations.findIndex(item =>
                      item.idPlanVentilation?.equals(e.data.idPlanVentilation)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedPlan.ventilations];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        ventilations: updatedData
                      }));
                      setIsFieldModifier(true);
                    }
                  }}
                >
                  <Editing
                    mode='cell'
                    allowAdding={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowUpdating={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"}
                  />
                  <Column caption={"Folio"} dataField={"idFolio"}>
                    <Lookup {...folioEditorOption} />
                  </Column>
                  <Column caption={"Montant"} dataField='montant' dataType='number' format='fixedPoint' />
                  <Column caption={"TPS"} dataField='paieTps' dataType='boolean' />
                  <Column caption={"TVQ"} dataField='paieTvq' dataType='boolean' />
                  <Column caption={"Héb. taxe"} dataField='taxeHebergement' dataType='boolean' />
                  <Column caption={"Balance"} dataField='balance' dataType='boolean' />
                  <Column caption={"Mode de calcul"} dataField='modeCalcul'>
                    <Lookup {...modeCalculEditorOption} />
                  </Column>
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                </DataGrid>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Rapports">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPlan || {} as IPlanEntete} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <SimpleItem key={"frm-activite"} dataField={"idActivite"} editorType={"dxSelectBox"}
                editorOptions={activitesEditorOption}
              >
                <Label text={"Activité (Statistiques d'hébergement annuel)"} />
              </SimpleItem>
              <SimpleItem key={"frm-ordre-affichage"}
                dataField={"ordreAffichage"}
                editorType={"dxNumberBox"}
                editorOptions={nombrePersonnesOptions}
              >
                <Label text={"Ordre d'affichage (Statistiques d'hébergement annuel)"} />
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="Tarification">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPlan || {} as IPlanEntete} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem caption={"Tarifications"} colCount={7}>
                <GroupItem colSpan={3}>
                  <DataGrid
                    showBorders={true}
                    allowColumnResizing={true}
                    dataSource={selectedPlan.tarifications}
                    allowColumnReordering={false}
                    filterValue={dataGridFilterValue}
                    height={"100%"}
                    onInitNewRow={(e: any) => {
                      e.data.idPlanEntete = selectedPlan.idPlanEntete;
                      e.data.isDeleted = false;
                    }}
                    onEditorPreparing={(e: any) => {
                      const originalOnValueChanged = e.editorOptions.onValueChanged;
                      e.editorOptions.onValueChanged = (args: any) => {
                        if (originalOnValueChanged) {
                          originalOnValueChanged(args);
                        }

                        const currentData = e.component.option("dataSource");
                        const rowIndex = e.rowIndex;
                        const rowData = currentData[rowIndex];

                        const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                        setSelectedDataRow(prev => ({
                          ...prev,
                          tarifications: updatedData
                        }));
                        setIsFieldModifier(true);
                      };
                    }}
                    onRowRemoving={async (e) => {
                      e.cancel = true;
                      const index = selectedPlan.tarifications.findIndex(item =>
                        item.idPlanDetailTarif?.equals(e.data.idPlanDetailTarif)
                      );
                      if (index !== -1) {
                        const updatedData = [...selectedPlan.tarifications];
                        updatedData[index] = { ...updatedData[index], isDeleted: true };
                        setSelectedDataRow(prev => ({
                          ...prev,
                          tarifications: updatedData
                        }));
                        setIsFieldModifier(true);
                      }
                    }}
                    onSelectionChanged={onTarificationSelectionChanged}
                  >
                    <Editing
                      mode='cell'
                      allowAdding={mode !== Mode.Lecture}
                      allowDeleting={mode !== Mode.Lecture}
                      allowUpdating={mode !== Mode.Lecture}
                      newRowPosition={"first"}
                      startEditAction={"dblClick"}
                    />
                    <Selection mode="single" />
                    <Column caption={"Priorité"} dataField='priorite' dataType='number' alignment="left" />
                    <Column caption={"Description française"} dataField='descriptionFrancaise' dataType='string' />
                    <Column caption={"Description anglaise"} dataField='descriptionAnglaise' dataType='string' />
                    <Column dataField="isDeleted" dataType="boolean" visible={false} />
                  </DataGrid>
                </GroupItem>
                <GroupItem colSpan={4}>
                  <GroupItem colCount={2}>
                    <SimpleItem key={"frm-date-input"}>
                      <SelectBox
                        disabled={mode === Mode.Lecture}
                        value={moisSelectionne}
                        onValueChanged={(e) => setMoisSelectionne(e.value)}
                        items={mois} />
                    </SimpleItem>
                    <SimpleItem key={"frm-date-calendar"}>
                      <NumberBox
                        disabled={mode === Mode.Lecture}
                        onValueChanged={(e) => setAnneSelectionnee(e.value)}
                        min={1970}
                        value={anneSelectionnee}
                        showSpinButtons={true} />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem>
                    <CalendarCustom
                      disabled={mode === Mode.Lecture}
                      dataSource={dataTarification?.planDetailDate ?? []}
                      onValueMonthChange={(value) => {
                        setIsFieldModifier(true);
                        setMoisSelectionne(value);
                      }}
                      onValueYearChange={(value) => {
                        setIsFieldModifier(true);
                        setAnneSelectionnee(value);
                      }}
                      currentMonth={moisSelectionne}
                      currentYear={anneSelectionnee}
                    />
                  </GroupItem>
                </GroupItem>
              </GroupItem>
              <GroupItem caption={"Détails de prix"} colCount={4}>
                <GroupItem colSpan={3}>
                  <DataGrid
                    dataSource={selectedPlan.conditions}
                    allowColumnReordering={false}
                    filterValue={dataGridFilterValue}
                    height={"100%"}
                    onInitNewRow={(e: any) => {
                      e.data.idPlanEntete = selectedPlan.idPlanEntete;
                      e.data.isDeleted = false;
                    }}
                    onEditorPreparing={(e: any) => {
                      const originalOnValueChanged = e.editorOptions.onValueChanged;
                      e.editorOptions.onValueChanged = (args: any) => {
                        if (originalOnValueChanged) {
                          originalOnValueChanged(args);
                        }

                        const currentData = e.component.option("dataSource");
                        const rowIndex = e.rowIndex;
                        const rowData = currentData[rowIndex];

                        const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                        setSelectedDataRow(prev => ({
                          ...prev,
                          conditions: updatedData
                        }));
                        setIsFieldModifier(true);
                      };
                    }}
                    onRowRemoving={async (e) => {
                      e.cancel = true;
                      const index = selectedPlan.conditions.findIndex(item =>
                        item.idPlanDetailCondition?.equals(e.data.idPlanDetailCondition)
                      );
                      if (index !== -1) {
                        const updatedData = [...selectedPlan.conditions];
                        updatedData[index] = { ...updatedData[index], isDeleted: true };
                        setSelectedDataRow(prev => ({
                          ...prev,
                          conditions: updatedData
                        }));
                        setIsFieldModifier(true);
                      }
                    }}
                  >
                    <Editing
                      mode='cell'
                      allowAdding={mode !== Mode.Lecture}
                      allowDeleting={mode !== Mode.Lecture}
                      allowUpdating={mode !== Mode.Lecture}
                      newRowPosition={"first"}
                      startEditAction={"click"}
                    />
                    <Column caption={"Durée de"} dataField='dureeDe' dataType='number' alignment='left' />
                    <Column caption={"Durée à"} dataField='dureeA' dataType='number' alignment='left' />
                    <Column caption={"Nb. de pers. de"} dataField='nombrePersonnesDe' dataType='number' alignment='left' />
                    <Column caption={"Nb. de pers. à"} dataField='nombrePersonnesA' dataType='number' alignment='left' />
                    <Column caption={"Mode de calcul"} dataField='modeCalculHebergement'>
                      <Lookup {...modeCalculDetailsPrixTarificationEditorOption} />
                    </Column>
                    <Column dataField="isDeleted" dataType="boolean" visible={false} />
                  </DataGrid>
                </GroupItem>
                <GroupItem>
                  <DataGrid
                    showBorders={true}
                    allowColumnResizing={true}>
                    <Editing
                      mode='cell'
                      allowAdding={mode !== Mode.Lecture}
                      allowDeleting={mode !== Mode.Lecture}
                      allowUpdating={mode !== Mode.Lecture} />
                    <Column caption={"Tranche d'âge"} dataField='idTrancheAge'>
                      <Lookup {...trancheAgeEditorOption} />
                    </Column>
                    <Column caption={"Prix"} dataField='prix' dataType='number' alignment='left' />
                  </DataGrid>
                </GroupItem>

              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedPlan || {} as IPlanEntete} /></TabItem>
        </FormListBaseTab> : null
      }
      <PopupSelectionColonnes
        visible={isPopupSelectionColonnesVisible}
        onClose={() => setIsPopupSelectionColonnesVisible(false)}
        onApply={(parametres) => {
          setIsFieldModifier(true);
          setSelectedDataRow(prev => ({
            ...prev,
            parametres: parametres
          }));
        }}
        parametres={selectedPlan?.parametres}
        idPlanEntete={selectedPlan?.idPlanEntete}
      />
    </FormListBase >
  );
}